var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfIconLlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,50A50,50,0,1,1,50,0,50,50,0,0,1,100,50ZM56.64,19.92a18.37,18.37,0,0,0-11.83-.36c-32.9,9.91-.45,54.54,4.74,61.36a.83.83,0,0,0,1.33,0C82.69,37,66.87,23.81,56.64,19.92ZM50,46.74a9.06,9.06,0,1,1,9.06-9.06A9.06,9.06,0,0,1,50,46.74Z",
    fill: "#57ba49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfIconLlm);
export default __webpack_public_path__ + "static/media/bf-icon-llm.d635779de60934826117df83f0f903ff.svg";
export { ForwardRef as ReactComponent };